'use client';

import { Toman } from '@insta-club/components/icons';
import { Plan } from '@insta-club/models';
import { cva } from 'class-variance-authority';
import CheckBox from 'src/libs/ui/button/checkbox';
import { calculateDiscountPercentage, separator } from 'src/libs/utilities/number';

interface Props {
    plan: Plan;
    selected: boolean;
    onSelect: (plan: Plan) => void;
}

const containerVariants = cva('border rounded-lg flex flex-col gap-2 py-2 px-3 cursor-pointer overflow-hidden', {
    variants: {
        variant: {
            default: 'border-gray-300',
            selected: 'border-primary-500 selected',
            disabled: 'border-gray-200 bg-gray-200 cursor-not-allowed pointer-events-none'
        }
    },
    defaultVariants: {
        variant: 'default'
    }
});

const PlanItem: React.FC<Props> = ({ plan, selected, onSelect }) => {
    const disabled = plan.total_capacity > 0 && plan.remaining_capacity <= 0;
    const variant = disabled ? 'disabled' : selected ? 'selected' : 'default';

    const handleSelect = () => {
        onSelect(plan);
    };

    return (
        <div onClick={handleSelect} className={containerVariants({ variant })}>
            <div className='flex'>
                <div className='flex flex-1 items-center gap-2'>
                    <div>{!disabled && <CheckBox checked={selected} />}</div>

                    {/* [.selected_&]:font-semibold */}
                    <span className='relative top-0.5 flex-1 text-base font-semibold text-nowrap'>{plan.name}</span>
                </div>

                {plan.remaining_capacity === 0 ? (
                    <span className='bg-secondary-500 rounded-full px-2 py-0.5 text-xs font-medium text-white'>
                        تکمیل ظرفیت
                    </span>
                ) : (
                    <div className='flex flex-col items-end md:flex-row-reverse md:gap-2'>
                        <div className='flex items-center gap-1'>
                            <span className='relative top-0.5 text-base font-semibold text-gray-800'>
                                {separator(plan.amount)}
                            </span>
                            <Toman className='text-gray-800' />
                        </div>
                        {plan.show_amount ? (
                            <div className='flex items-center gap-1'>
                                <span className='bg-danger-600 rounded px-1 pt-2.5 pb-2 text-xs leading-0 font-medium text-white'>
                                    %{calculateDiscountPercentage(plan.amount, plan.show_amount)}
                                </span>
                                <span className='text-sm text-gray-500 line-through'>
                                    {separator(plan.show_amount)}
                                </span>
                            </div>
                        ) : null}
                    </div>
                )}
            </div>
            <p className='text-xs font-normal text-gray-600'>{plan.description}</p>
        </div>
    );
};

export default PlanItem;

